import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lightbulb, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export const FactCard = () => {
  const { t } = useApp();
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/learn/fact").then((r) => setF(r.data.fact)).catch(() => {}); }, []);
  if (!f) return null;
  return (
    <Link to="/learn" data-testid="home-fact-card" className="ks-rise flex items-start gap-3 rounded-3xl border-2 border-dashed border-[#2E9E6B]/50 bg-white p-4">
      <Lightbulb className="mt-0.5 h-6 w-6 shrink-0 text-[#E05C3A]" />
      <div className="flex-1">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#2E9E6B]">{t("Did you know?")}</p>
        <p className="text-sm font-semibold text-[#0D3B2B]" data-testid="home-fact-text">{t(f)}</p>
        <p className="mt-1 text-xs text-[#4A6358]">{t("Take today's quiz for Green Points")}</p>
      </div>
      <ChevronRight className="h-5 w-5 self-center text-[#7B968B]" />
    </Link>
  );
};
